(function (angular) {
	'use strict';

	angular
		.module('baseCheckoutModule')
		.controller('CheckoutIraProfileForm', [
			'globalConfig',
			CheckoutIraProfileFormFunction
		]);

	function CheckoutIraProfileFormFunction(
		globalConfig) {
		var checkout = this;
		
		checkout.formValues = globalConfig.formValues;
	}
})(window.angular);